import React, { memo } from 'react';

import ShapesIcon from '@atlaskit/icon/core/shapes';
import {
	PreviewPanel,
	PreviewPanelBody,
	PreviewPanelHeader,
	PreviewPanelTitle,
} from '@atlassian/preview-panel';
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api';

type Props = {
	name: string;
	url: string;
};

export const DummyPreviewPanel = memo(({ name, url }: Props) => {
	const { close } = usePreviewPanelsActions();

	return (
		<PreviewPanel>
			<PreviewPanelHeader onClose={close} url={url}>
				<PreviewPanelTitle title={name} icon={<ShapesIcon label="" />} />
			</PreviewPanelHeader>
			<PreviewPanelBody>
				This is a dummy preview panel. It can be used to test the layout and functionality of the
				preview panel without needing a real content source.
			</PreviewPanelBody>
		</PreviewPanel>
	);
});
